const {
  REACT_APP_FIRSTREVIEWER,
  REACT_APP_SECONDREVIEWER,
  REACT_APP_THIRDREVIEWER,
  REACT_APP_SYSTEMADMINISTRATOR,
  REACT_APP_REVIEWERADMINISTRATOR,
} = process.env;

const RoleRules = {
  URDIAccess: [
    REACT_APP_FIRSTREVIEWER!,
    REACT_APP_SECONDREVIEWER!,
    REACT_APP_THIRDREVIEWER!,
    REACT_APP_SYSTEMADMINISTRATOR!,
    REACT_APP_REVIEWERADMINISTRATOR!,
  ],
  FirstReviewer: [
    REACT_APP_FIRSTREVIEWER!,
    // "9d290ab9-8995-4cf6-838d-aefa435eaf28",
  ],

  SecondReviewer: [
    REACT_APP_SECONDREVIEWER!,
    // "bc052bc1-70a2-449a-8b4a-12403526623b",
  ],

  ThirdReviewer: [
    REACT_APP_THIRDREVIEWER!,
    // "9bec911e-479c-482d-b884-547e5f44a472",
  ],

  SystemAdmin: [
    REACT_APP_SYSTEMADMINISTRATOR!,
    // "c2da88c9-b29c-41ec-a346-5bc2977e4113"
  ],
  ReviewerAdmin: [
    REACT_APP_REVIEWERADMINISTRATOR!,
    // "6fa1404c-80b1-40df-856d-444a49837848"
  ],
};

export default RoleRules;
